module.exports = __webpack_public_path__ + "img/les-pigments-deternite-premiere-home.976b7911.png";